import React from 'react';
import { ShowcaseBoxContent } from '../../../types/content';
import WalletTopBanner from './WalletTopBanner';
import StaticImage from '../../UI/Image/StaticImage';

interface IBoxTwoProps {
  content: ShowcaseBoxContent;
}

const BoxTwo = ({ content }: IBoxTwoProps) => {
  return (
    <div className='guide-box guide-box__two'>
      <WalletTopBanner
        title={content.banner.title}
        targetAmount={content.banner.target_amount}
      />
      <div className='middle-section-games'>
        <StaticImage imageName='guide_games' extension='png' altText='games' />
      </div>
    </div>
  );
};

export default BoxTwo;
